// Only protected, internal routes may be resumed after authentication.
export function getLoginRedirect(router, value) {
  if (typeof value !== 'string' || !value.startsWith('/') || /^\/[/\\]/.test(value)) return ''
  const route = router.resolve(value).route
  return route.matched.some(record => record.meta && record.meta.requireAuth)
    ? route.fullPath
    : ''
}

let expiredToken = ''
export function handleExpiredSession(vm, store, config = {}, message) {
  if (config.authMode === 'anonymous') return false
  const token = config.authToken
  if (!token || token !== store.getters.getToken) return false
  if (expiredToken === token) return true
  expiredToken = token
  const redirect = getLoginRedirect(vm.$router, vm.$route.fullPath)
  // Invalidate immediately; navigation must wait for the explicit confirmation.
  sessionStorage.removeItem('token')
  store.dispatch('asyUpdataToken', '')
  vm.$showTipsToast(26, {
    message: typeof message === 'string' && message.trim() ? message : '登录已失效，请重新登录。',
    confirm() {
      // A late confirmation must never clear a newer login.
      if (store.getters.getToken && store.getters.getToken !== token) {
        expiredToken = ''
        return
      }
      for (const key of ['userId', 'nickName', 'userType', 'bindHostState', 'aiCapabilities:v1', 'aiLoginEpoch'])
        sessionStorage.removeItem(key)
      store.dispatch('asyUpdataUserId', '')
      store.dispatch('asyResetRegionNavigation')
      expiredToken = ''
      if (vm.$route.name !== 'login')
        vm.$router.replace({ path: '/login', query: redirect ? { redirect } : {} })
    }
  }, false, 0, 0, true, false)
  return true
}
